<template>
    <div id="bfMerchants">
        <van-nav-bar title="缤纷商家" left-arrow @click-left="$router.go(-1)"/>
        <div class="bfMerchantsBody">
            <div class="bodyConten" v-for="index in 3" :key="index">
                <div class="bodyContenHeard clearfix">
                    <van-image src="https://img.yzcdn.cn/vant/cat.jpeg"/>
                    <div style="display:inline-block;float:left;padding-left:10px;">
                        <p class="heardTietle">良品铺子长沙总店</p>
                        <p class="heardDesc">销量520｜1.5万用户好评</p>
                    </div>
                </div>
                <div class="bodyContenBody">
                    <van-grid :border="false" :column-num="3" class="bodyContenBodyGrid">
                        <van-grid-item>
                            <van-image src="https://img.yzcdn.cn/vant/apple-1.jpg" />
                            <div class="gridItemTitle">
                                <p class="pTitle">三只松鼠碧根鼠碧根</p>
                                <p class="priceTitle">￥169.90</p>
                            </div>
                        </van-grid-item>
                        <van-grid-item>
                            <van-image src="https://img.yzcdn.cn/vant/apple-1.jpg" />
                            <div class="gridItemTitle">
                                <p class="pTitle">三只松鼠碧根鼠碧根</p>
                                <p class="priceTitle">￥169.90</p>
                            </div>
                        </van-grid-item>
                        <van-grid-item>
                            <van-image src="https://img.yzcdn.cn/vant/apple-1.jpg" />
                            <div class="gridItemTitle">
                                <p class="pTitle">三只松鼠碧根鼠碧根</p>
                                <p class="priceTitle">￥169.90</p>
                            </div>
                        </van-grid-item>
                    </van-grid>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BfMerchants',
    data() {
        return {

        };
    },
    methods: {

    },
    created() {

    }
};
</script>
<style lang="scss">
    #bfMerchants{
        .van-nav-bar{
            background: #DEA286;
            padding-bottom: 50px;
            .van-nav-bar__left{
                top: 0;
            }
            .van-icon-arrow-left{
                font-size: 21px;
                color: #fff;
            }
            .van-nav-bar__title{
                font-size:21px;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(255,255,255,1);
            }
        }
        .bfMerchantsBody{
            padding: 0 13px;
            position: relative;
            top: -45px;
            z-index: 999;
            .bodyConten:last-child{
                margin-bottom: 0;
            }
            .bodyConten{
                background:#fff;
                border-radius:5px;
                padding: 0 10px 8px;
                margin-bottom: 30px;
                .bodyContenHeard{
                    text-align: left;
                    .van-image{
                        float: left;
                        width:60px;
                        height: 60px;
                        img{
                            position: relative;
                            top: -10px;
                            z-index: 9999;
                            border-radius:3px;
                        }
                    }
                    .heardTietle{
                        font-size:18px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(0,0,0,1);
                        line-height:35px;
                    }
                    .heardDesc{
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(159,159,159,1);
                    }
                }
                .bodyContenBody{
                    .bodyContenBodyGrid{
                        .van-grid-item__content{
                            padding: 0 5px;
                        }
                        .van-image{
                            img{
                                width: 100%;
                                height:95px;
                                border-radius:5px;
                            }
                        }
                        .gridItemTitle{
                            text-align: left;
                            width: 100%;
                            padding: 5px 0;
                            background: #FAFAFA;
                            border-radius:5px;
                            .pTitle{
                                white-space: nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                width: 90px;
                                font-size:12px;
                                font-family:PingFang SC;
                                font-weight:bold;
                                color:rgba(51,51,51,1);
                                line-height:20px;
                                margin-left: 5px;
                            }
                            .priceTitle{
                                margin-left: 5px;
                                font-size:10px;
                                font-family:PingFang SC;
                                font-weight:bold;
                                color:rgba(232,91,77,1);
                                line-height:18px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
